import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ais-ui/ui-core';
import { useMemo, useState, useEffect } from 'react';
import { HistoricalAtonChart } from './HistoricalAtonChart';
import { AtonHostDetails } from '../../types';

interface HistoricalAtonCardProps {
  aton: AtonHostDetails;
}

const formatLabel = (id: string): string => {
  return id
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const HistoricalAtonCard = ({ aton }: HistoricalAtonCardProps) => {
  const [selectedValue, setSelectedValue] = useState<string>('');

  const selectables = useMemo(() => {
    if (!aton.monitors) {
      return [];
    }

    return aton.monitors
      .filter((monitor) => monitor.serviceKey) // Only include monitors with service keys
      .map((monitor) => ({
        id: monitor.serviceKey!,
        label: formatLabel(monitor.serviceKey!),
        monitor,
      }));
  }, [aton.monitors]);

  // Preselect the first option when selectables change
  useEffect(() => {
    if (selectables.length > 0 && !selectedValue) {
      setSelectedValue(selectables[0].id);
    }
  }, [selectables, selectedValue]);

  return (
    <Card className="col-span-4 p-4">
      <CardHeader className="space-y-8">
        <CardTitle>Historical AtoN data</CardTitle>
        <Select value={selectedValue} onValueChange={setSelectedValue}>
          <SelectTrigger className="w-[240px] text-md">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {selectables.map((item) => (
              <SelectItem key={item.id} value={item.id}>
                {item.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent className="pl-2">
        <HistoricalAtonChart aton={aton} serviceName={selectedValue} />
      </CardContent>
    </Card>
  );
};
